import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { User } from 'app/core/user/user.types';
import { BaseRequestService } from 'app/_services/base.service';
import { MyToastrService } from 'app/_services/toastr.service';

@Component({
    selector: 'app-device-registration',
    standalone: true,
    imports: [
        NgIf, // 🔥 REQUIRED for *ngIf
        NgFor, // 🔥 REQUIRED for *ngFor
        ReactiveFormsModule, // 🔥 REQUIRED for forms
    ],

    templateUrl: './device-registration.component.html',
    styleUrls: ['./device-registration.component.scss'],
})
export class DeviceRegistrationComponent implements OnInit {
    inventoryList: any[] = [];
    showDialog = false;
    user: User;
    deviceForm!: FormGroup;

    deviceTypes = ['C1', 'C2'];
    deviceTypeLabels = {
        "C1":"Critical",
        "C2":"Non-critical"
    }
    simStatusList = ['With SIM', 'Without SIM'];
    simOperators = ['Airtel', 'Jio', 'Vodafone'];
    userRole: any;

    constructor(
        private _bs: BaseRequestService,
        private fb: FormBuilder,
        private toast: MyToastrService,
        private _cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this._cd.detectChanges();
        this.getInventory();
        const localData = localStorage.getItem('user');
        this.userRole = localData ? JSON.parse(localData).role : null;
        this.deviceForm = this.fb.group({
            serial_number: ['', Validators.required],
            ChipID: ['', Validators.required],
            device_type: ['', Validators.required],
            sim_status: ['', Validators.required],
            sim_operator: [''],
            sim_serial_number: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(15)]],
        });

        // 🔥 Sync chip_id = serial_number
        this.deviceForm
            .get('serial_number')
            ?.valueChanges.subscribe((value) => {
                this.deviceForm
                    .get('ChipID')
                    ?.setValue(value, { emitEvent: false });
            });

        // 🔥 SIM status logic (FIXED key name)
        this.deviceForm.get('sim_status')?.valueChanges.subscribe((value) => {
            if (value === 'With SIM') {
                this.deviceForm
                    .get('sim_operator')
                    ?.setValidators(Validators.required);
                this.deviceForm
                    .get('sim_serial_number')
                    ?.setValidators([
                Validators.required, 
                Validators.minLength(10), 
                Validators.maxLength(15)
            ]);
            } else {
                this.deviceForm.get('sim_operator')?.clearValidators();
                this.deviceForm.get('sim_serial_number')?.clearValidators();
                this.deviceForm.patchValue({
                    sim_operator: '',
                    sim_serial_number: '',
                });
            }

            this.deviceForm.get('sim_operator')?.updateValueAndValidity();
            this.deviceForm.get('sim_serial_number')?.updateValueAndValidity();
        });
    }

    getInventory() {
        this._bs
            .doRequest('/api/inventory', 'get', {})
            .subscribe((result: any) => {
                console.log('Inventory API response:', result);

                if (Array.isArray(result?.data)) {
                    this.inventoryList = result.data;
                } else {
                    this.inventoryList = [];
                }
            });
    }

    registerDevice() {
        this.showDialog = true;

    }

    closeDialog() {
        this.showDialog = false;
        this.deviceForm.reset();
    }

    submitDevice() {
        if (this.deviceForm.valid) {
            const payload = this.deviceForm.value;

            this._bs.doRequest('/api/inventory', 'post', payload).subscribe(
                (result: any) => {
                    if (result?.status) {
                        console.log('Device Registered Successfully:', result);
                        this.toast.sToast(
                            'success',
                            'IoT serial number ' +
                                payload.serial_number +
                                ' registered Successfully'
                        );

                        this.getInventory();

                        // 🔒 Close dialog
                        this.closeDialog();
                    } else {
                        this.toast.sToast(
                            'error',
                            result?.message || 'Device Registration Failed'
                        );
                    }
                },
                (error: any) => {
                    console.error('Device Registration Failed:', error);
                }
            );
        }
        this.deviceForm.markAsTouched();
        this._cd.detectChanges();

    }
}
